// extracted by mini-css-extract-plugin
module.exports = {"moreOptions":"PopupMenu_moreOptions__2Jr2U","tooltip":"PopupMenu_tooltip__av5s0","tooltipContainer":"PopupMenu_tooltipContainer__1HyCZ"};